import { render } from "./ReviewWelcomeModal.vue?vue&type=template&id=fdfe2ea2&scoped=true"
import script from "./ReviewWelcomeModal.vue?vue&type=script&lang=js"
export * from "./ReviewWelcomeModal.vue?vue&type=script&lang=js"

import "./ReviewWelcomeModal.vue?vue&type=style&index=0&id=fdfe2ea2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfe2ea2"],['__file',"src/scripts/view/review/modals/ReviewWelcomeModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdfe2ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdfe2ea2', __exports__)) {
    api.reload('fdfe2ea2', __exports__)
  }
  
  module.hot.accept("./ReviewWelcomeModal.vue?vue&type=template&id=fdfe2ea2&scoped=true", () => {
    api.rerender('fdfe2ea2', render)
  })

}


export default __exports__